import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function chartKpiLabel(theme: Theme): ComponentStyle {
  return {
    componentName: 'chartKpiLabel',
    baseStyle: {
      fontSize: theme.sizes['-1'],
      color: theme.colors.spark.gray30,
      fontWeight: 500
    }
  };
}
